<table class="table --table-filters" [ngClass]="['table', style, size]" *ngIf="filter || pagination">
  <sp-table-filters
    [header]="header"
    [mutating]="mutating"
    [dynamicColumns]="dynamicColumns"
    [filter]="filter"
    [tableSearch]="tableSearch"
    [filterInputs]="filterInputs"
    [query]="query"
    [dateQuery]="dateQuery"
    [basicQuery]="basicQuery"
    [size]="size"
    [paginate]="paginate"
    [DataService]="DataService"
    [pagination]="pagination"
  >
  </sp-table-filters>
</table>
<table class="table" [ngClass]="['table', style, size]">
  <sp-table-head
    #tableHead
    [withCheckbox]="withCheckbox"
    *ngIf="header"
    [header]="header"
    [query]="query"
    [dateQuery]="dateQuery"
    [basicQuery]="basicQuery"
    [DataService]="DataService"
    (propagateChecked)="getHeaderCheck($event)"
  ></sp-table-head>
  <sp-table-body
    *ngIf="rows"
    [rows]="rows"
    [header]="header"
    [query]="query"
    [dateQuery]="dateQuery"
    [basicQuery]="basicQuery"
    [DataService]="DataService"
    [withCheckbox]="withCheckbox"
    (propagateCheck)="getCheckedRows()"
  ></sp-table-body>
  <ng-content></ng-content>
</table>
<table class="table --table-filters" [ngClass]="['table', style, size]" *ngIf="pagination">
  <sp-table-footer
    #tableFooter
    [query]="query"
    [dateQuery]="dateQuery"
    [basicQuery]="basicQuery"
    [DataService]="DataService"
    [paginate]="paginate"
    [pagination]="pagination"
  ></sp-table-footer>
</table>
